"use client";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";
// Import your language translation files
import translationZod from "../public/locales/es-ar/zod.json";

const path = require('path');
const localPath =  path.resolve('./public/locales') ;

import translationSpanish from "../public/locales/es-ar/clients.json";
import translationSubAccount from "../public/locales/es-ar/subaccount.json";
import translationStock from "../public/locales/es-ar/stock.json";

//---Using different namespaces
const resources = {   
    esAR: {
        clients: translationSpanish,
        subaccount: translationSubAccount,
        stock: translationStock,
        zod: translationZod,
    },   
}

i18next
.use(initReactI18next)
.init({
  resources,
  lng:"esAR", //default language
});

z.setErrorMap(zodI18nMap);

// export configured zod instance
export { z }

export default i18next;